module.exports = __webpack_public_path__ + "img/2.33df1fbf.jpg";